var _path, _g, _g2, _path2, _path3, _path4, _g3, _g4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 284,
    viewBox: "0 0 192 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4484 185.549C100.887 176.942 108.745 171.002 117.691 171.002H172.303C179.172 171.002 184.361 177.229 183.122 183.986L168.402 264.252H102.601C89.331 264.252 79.7404 251.566 83.3583 238.799L98.4484 185.549Z",
    fill: "#A0B8D1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0026 137.173C56.1881 146.202 68.5528 151.262 81.433 151.262H132.078C141.974 151.262 146.512 157.729 148.589 169.486L165.16 264.252H52.0093C40.1936 264.252 29.8636 256.285 26.8621 244.857L0.844039 145.794C0.377877 139.755 4.89556 134.86 10.9346 134.86H41.3499C43.4645 134.86 45.4946 135.691 47.0026 137.173Z",
    fill: "#CAECFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.390738,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2285 198.027C51.2285 197.256 51.6243 196.539 52.309 196.185C53.8329 195.398 56.7444 194.119 59.5738 194.119C62.4022 194.119 65.2306 195.397 66.7044 196.184C67.3684 196.539 67.7478 197.242 67.7478 197.995C67.7478 199.769 65.7049 200.931 64.0359 200.33C62.696 199.848 61.1205 199.457 59.5322 199.457C57.9124 199.457 56.2926 199.864 54.9193 200.359C53.2536 200.96 51.2285 199.798 51.2285 198.027Z",
    fill: "#1B3554"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.390738,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8146 198.027C92.8146 197.256 93.2104 196.539 93.895 196.185C95.4189 195.398 98.3304 194.119 101.16 194.119C103.988 194.119 106.817 195.397 108.29 196.184C108.955 196.539 109.334 197.242 109.334 197.995C109.334 199.769 107.291 200.931 105.622 200.33C104.282 199.848 102.707 199.457 101.118 199.457C99.4984 199.457 97.8787 199.864 96.5054 200.359C94.8396 200.96 92.8146 199.798 92.8146 198.027Z",
    fill: "#1B3554"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.390738,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1924 224.971C88.8296 224.971 95.0207 219.283 95.0207 209.548C81.1924 209.491 78.2179 209.83 67.3641 209.548C67.3641 219.283 73.5552 224.971 81.1924 224.971Z",
    fill: "#1B3554"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9297 85.6977C73.3593 98.744 67.9274 115.747 58.8632 129.454C70.7316 131.847 91.5678 133.867 107.94 133.952C108.719 133.956 110.868 133 111.599 132.909C116.018 132.358 117.458 128.59 118.776 127.185C123.248 118.256 128.202 111.281 128.532 100.573C128.702 95.0833 128.363 90.5562 127.848 88.7252C121 85.4036 108.296 89.441 66.9297 85.6977Z",
    fill: "#FF96BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.603 123.558C114.612 126.213 112.354 133.838 106.724 134.002C112.702 133.769 115.81 131.428 118.017 129.127C120.223 126.826 130.588 116.14 127.814 88.7709C129.205 111.958 124.097 123.58 111.603 123.558Z",
    fill: "#F46DA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.915 30.2114C178.915 30.2114 181.183 35.1973 182.459 39.5529C184.229 45.5977 182.813 52.4697 182.502 52.5377C180.808 52.9091 175.047 44.8035 175.138 40.0511C175.22 35.7775 178.915 30.2114 178.915 30.2114Z",
    fill: "#FFB883"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.3655 46.3613C98.3655 46.3613 132.018 38.3826 143.74 11.7088C148.675 12.8038 157.356 17.1336 178.466 29.7519C181.414 31.5145 175.174 39.9971 175.174 39.9971C175.174 39.9971 185.002 48.5857 182.587 52.0178C168.631 71.8551 157.475 79.0598 144.633 79.5281C124.718 74.651 98.3655 46.3613 98.3655 46.3613Z",
    fill: "#FFDF87"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.654 273.547C172.511 273.547 179.692 266.367 179.692 257.51C179.692 248.652 172.511 241.472 163.654 241.472C154.797 241.472 147.617 248.652 147.617 257.51C147.617 266.367 154.797 273.547 163.654 273.547Z",
    fill: "#44CEFF"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.23 262.485C161.497 262.752 161.846 262.886 162.196 262.886C162.546 262.886 162.895 262.752 163.163 262.485L169.997 255.651C170.531 255.117 170.531 254.252 169.997 253.718C169.463 253.184 168.598 253.184 168.064 253.718L162.196 259.585L159.062 256.452C158.528 255.918 157.663 255.918 157.129 256.452C156.596 256.986 156.596 257.851 157.129 258.385L161.23 262.485Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.810974,
    y: 131.86,
    width: 172.349,
    height: 132.393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: -3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.893149 0 0 0 0 0.893149 0 0 0 0 0.893149 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 98.3655,
    y: 11.709,
    width: 84.6036,
    height: 101.819,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 34
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.207843 0 0 0 0 0.329412 0 0 0 0.272192 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 139.617,
    y: 235.472,
    width: 48.0748,
    height: 48.0748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.266237 0 0 0 0 0.80796 0 0 0 0 1 0 0 0 0.527853 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.7cf7c7ba36a14be885db241477c67ffb.svg";
export { ForwardRef as ReactComponent };